import React from 'react'



import styled from 'styled-components'

const Center = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
`

const Spinner = ({ size = 'large' }) => {
  const dim = size === 'large' ? 350 : size === 'small' ? 120 : 200
  return (
    <Center>
      <div style={{
        position: 'relative',
        width: dim,
        height: dim,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      }}>
        <img
          src="https://cdn.dribbble.com/userupload/41873250/file/original-c1e686274607c93bf677e82782e79f5a.gif"
          alt="Loading..."
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'contain',
            mixBlendMode: 'multiply', // Effectively removes white background
            animation: 'fadeIn 0.6s ease-out'
          }}
        />
      </div>
      <style>{`
        @keyframes fadeIn {
          from { opacity: 0; transform: scale(0.9); }
          to { opacity: 1; transform: scale(1); }
        }
      `}</style>
    </Center>
  )
}

export default Spinner
